// HASC Phase 2 view helpers for components/HascRegistration.jsx (review fixes
// 2026-09-23). Pure ESM with no imports, so server/test/hascView.test.js runs
// them side by side with the server's own rules (services/hascRegistration.js)
// and a drift fails CI.
//
// DISPLAY ONLY. Nothing here decides money: the server re-checks every one of
// these before it books.

// The server's codeAlternates: a requirement code as typed, "/" alternates
// split, each one letters / digits / space . _ - starting with a letter or a
// digit, 40 max, deduped case-insensitively. [] = nothing HASC can take, so
// the Register button stays off (the options route would answer 400).
const CODE_RE = /^[A-Za-z0-9][A-Za-z0-9 ._-]*$/;
const CODE_MAX = 40;
export function hascCodes(v) {
  const seen = new Set();
  const out = [];
  for (const part of String(v == null ? '' : v).split('/')) {
    const c = part.trim();
    if (!CODE_RE.test(c) || c.length > CODE_MAX || seen.has(c.toLowerCase())) continue;
    seen.add(c.toLowerCase());
    out.push(c);
  }
  return out;
}

// YYYY-MM-DD plus n days, anchored at noon UTC so DST never moves the day.
// null for anything that is not a YYYY-MM-DD date.
export function addDaysIso(iso, n) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(iso == null ? '' : iso))) return null;
  const d = new Date(`${iso}T12:00:00Z`);
  if (Number.isNaN(d.getTime())) return null;
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}
// Bulk chunks of at most `max` items that never split one employee's classes
// across two calls: the server sends ONE email per employee per call, and the
// spec says one email per employee listing all of their new registrations.
// Employees keep the order of their first row. One employee with more than
// `max` items (not realistic) is split rather than refused.
export function chunkByEmployee(list, max, employeeOf) {
  const size = Math.max(1, Number(max) || 1);
  const groups = [];
  const at = new Map();
  for (const x of list || []) {
    const k = String(employeeOf(x));
    if (!at.has(k)) { at.set(k, groups.length); groups.push([]); }
    groups[at.get(k)].push(x);
  }
  const chunks = [];
  let cur = [];
  for (const g of groups) {
    if (cur.length && cur.length + g.length > size) { chunks.push(cur); cur = []; }
    for (const x of g) {
      if (cur.length >= size) { chunks.push(cur); cur = []; }
      cur.push(x);
    }
  }
  if (cur.length) chunks.push(cur);
  return chunks;
}

// A bulk result that MAY be booked at HASC, so it must never read as "not
// registered": the row is Unconfirmed (HASC did not confirm, or answered with
// an error but returned a registration id), its batch request failed in
// flight (`unknown`), or the server hit an unexpected error on the row.
export const mayBeBooked = (r) => !!(r && !r.ok && (r.unknown || r.status === 500
  || (r.registration && r.registration.status === 'Unconfirmed')));
